<template>
  <div class="material">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>展会管理</BreadcrumbItem>
          <BreadcrumbItem>展会计划</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">展会计划</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="add" :disabled-hover="false">
          <span class="htb-add">+</span>
          <span>添加展会</span>
        </div>
      </div>
    </div>

    <div class="eh-content" v-if="planList.length">
      <Row :gutter="30">
        <Col
          :md="12"
          style="float: left;width: 20%;"
          v-for="(item, index) in planList"
          :key="'releaseInt-' + index"
          class="w-20"
        >
          <!-- 会刊信息 -->
          <div class="pro pro-over">
            <div class="pro-top">
              <img v-if="item.cover" :src="item.cover" />
              <img v-else src="@assets/img/empty.png" />
            </div>
            <p class="plan-p" :title="item.name">{{item.name}}</p>
            <div class="pro-tool">
              <div class="pro-tool-item" @click="editModal(item)">编辑</div>
              <div class="pro-tool-line"></div>
              <div class="pro-tool-item z-del">
                <Poptip confirm title="您确认删除这条内容吗？" @on-ok="delItem(item)">删除</Poptip>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>

    <emptyList v-else @change="add()"></emptyList>

    <!-- 弹框 -->
    <addModel
      :show="showModel"
      :modelTitle="modelTitle"
      :options="options"
      @finish="init()"
      @close="showModel=false"
    ></addModel>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import addModel from "./plan-add";
import emptyList from "@components/emptyList/emptyList";

export default {
  name: "project-set",
  data() {
    return {
      showModel: false,
      modelTitle: "",
      options: {},
      planList: []
    };
  },
  components: {
    addModel,
    emptyList
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
    header() {
      return this.$store.state.header;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      delExPlan: "categoryModule/delExPlan",
    }),
    init() {
      this.getFinishList();
    },
    getFinishList() {
      // 获取展会完成项
      this.$http
        .get(
          `/api/ExhibitionPlan/GetList`,
        )
        .then(res => {
          if (res.status === 200 && res.data) {
            this.planList = res.data;
            console.log("展会计划：",this.planList);
          }
        });
    },
    add() {
      this.showModel = true;
      this.modelTitle = "新增展会";
      this.options = {
        msg: null,
        model: null
      };
    },
    editModal(item) {
      this.showModel = true;
      this.modelTitle = "编辑展会";
      this.options = {
        msg: item,
        model: "edit"
      };
    },
    async delItem(item) {
      let bool = await this.delExPlan(item.id);
      if (bool && bool.successed) {
        this.$Message.success("删除成功！");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;
  button {
    margin-right: 20px;
  }
}
.eh {
  &-content {
    padding: 24px;
    min-width: 800px;
    .pro {
      height: 400px;
      background-color: #fafafa;
      box-shadow: 0px 2px 6px 0px rgba(136, 156, 176, 0.1);
      margin-bottom: 24px;
      &:hover {
        cursor: pointer;
      }
    }
    .pro-no {
      background-color: #fff;
      .common-bot {
        p {
          color: #333;
        }
      }
    }
    .pro-top {
      width: 100%;
      height: 300px;
      position: relative;
      background-color: #f8f9fb;
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
        max-height: 100%;
      }
    }
    .pro-bot {
      padding: 12px 24px 24px 24px;
      height: 160px;
    }
    .common-bot {
      position: relative;
      background: #fff;
      p {
        font-size: 14px;
        color: #333;
        line-height: 1.5;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
      }
      span {
        position: absolute;
      }
      .type-1 {
        right: 10px;
        bottom: 10px;
      }
      .type-2 {
        right: 20px;
        bottom: 5px;
        color: #ff0000;
      }
    }
    .pro-tool {
      display: flex;
      height: 50px;
      align-items: center;
      justify-content: space-around;
      background-color: #f7f9fa;
      .pro-tool-item {
        flex: 1;
        line-height: 50px;
        font-size: 14px;
        color: #808080;
        cursor: pointer;
        text-align: center;
        &:hover {
          color: #1890ff;
        }

        &.z-del {
          &:hover {
            color: #f00;
          }
        }
      }

      .pro-tool-line {
        background-color: #e8e8e8;
        font-size: 20px;
        width: 1px;
        height: 22px;
        background-color: #e8e8e8;
      }
    }
  }
}
.plan-p {
  width: 100%;
  height: 50px;
  background-color: #fff;
  line-height: 50px;
  padding: 0 15px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
</style>

